import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/faqs.json";

export const useFAQs = ({ group = null, sector = null } = {}) => {
  let items = useSourceFlowCollection(data);

  if (sector) {
    items = items.filter((item) => item?.sector?.includes(sector));
  }

  if (group) {
    items = items.filter((item) => item?.group?.includes(group));
  }

  return items;
};

export default useFAQs;
